const DEFAULT_CANONICAL_ORIGIN = "https://workspace.carmelinstitutions.in";
const DEFAULT_REDIRECT_ORIGINS = ["https://camel-web-manager.web.app"];

function parseOrigins(value: string | undefined): string[] {
  return value?.split(",").map((origin) => origin.trim()).filter(Boolean) ?? [];
}

export function getCanonicalRedirectTarget(
  currentUrl: string,
  canonicalOrigin = DEFAULT_CANONICAL_ORIGIN,
  redirectOrigins: string[] = DEFAULT_REDIRECT_ORIGINS,
): string | null {
  const url = new URL(currentUrl);
  if (!redirectOrigins.includes(url.origin) || url.origin === canonicalOrigin) return null;
  return `${canonicalOrigin}${url.pathname}${url.search}${url.hash}`;
}

export function getConfiguredRedirectOrigins(value: string | undefined): string[] {
  const origins = parseOrigins(value);
  return origins.length > 0 ? origins : DEFAULT_REDIRECT_ORIGINS;
}

export function getConfiguredCanonicalOrigin(value: string | undefined): string {
  return value?.trim() || DEFAULT_CANONICAL_ORIGIN;
}
